var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsdownimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31784 10.4226C8.31784 11.9215 7.61128 13 6.45413 13C5.81822 13 5.60006 12.6305 5.37197 11.7724C5.32549 11.595 5.30256 11.5085 5.27838 11.4238C5.21578 11.2034 5.1067 10.8284 4.95175 10.2999C4.94752 10.2858 4.94126 10.2723 4.93316 10.26L3.15745 7.50647C2.73703 6.85535 2.11682 6.35494 1.38795 6.07876L1.09479 5.96766C0.720461 5.82567 0.408643 5.55757 0.214129 5.21047C0.0196161 4.86337 -0.0451463 4.45948 0.0312228 4.06978L0.281619 2.78939C0.354893 2.41511 0.534937 2.06945 0.80043 1.79336C1.06592 1.51727 1.40574 1.32231 1.77966 1.23156L6.50743 0.0837498C7.26115 -0.0991154 8.05729 0.0201235 8.7227 0.415535C9.38811 0.810946 9.86897 1.45055 10.0607 2.19523L10.9377 5.60184C11.0134 5.89635 11.0202 6.20411 10.9575 6.50162C10.8948 6.79913 10.7643 7.07851 10.576 7.31845C10.3876 7.55839 10.1464 7.75254 9.87075 7.88608C9.59508 8.01962 9.29224 8.08901 8.98536 8.08896H7.8561C8.16352 9.0913 8.31846 9.8647 8.31846 10.4226H8.31784Z",
    fill: "#DF6438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsdownimg);
export default __webpack_public_path__ + "static/media/thumbsdownimg.9a7f269c5fe0f798097a4d9ca283a7b6.svg";
export { ForwardRef as ReactComponent };